import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './index.scss';
import './common/style/globals.scss';
import reportWebVitals from './reportWebVitals';
import Login from './pages/login/Login';
import JuchuNyuryokuComponent from './pages/juchuNyuryoku/JuchuNyuryoku';
import 'moment/locale/ja';
import AuthenticatedGuard from './common/compornents/AuthenticatedGuard';
import JuchuShokaiComponent from './pages/juchuShokai/JuchuShokai';

function App() {
  return (
    <Switch>
      <Route exact path="/login">
        <Login />
      </Route>
      {/* AuthenticatedGuard 配下の Route は認証チェックあり（未認証とのときは/loginへ遷移） */}
      <AuthenticatedGuard>
        <Switch>
          <Route exact path="/juchu-nyuryoku">
            <JuchuNyuryokuComponent />
          </Route>
          <Route exact path="/juchuShokai/:yobidashimotoKbn">
            <JuchuShokaiComponent />
          </Route>
        </Switch>
      </AuthenticatedGuard>
    </Switch>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App></App>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
